import styled from 'styled-components';
import { media } from '../../../Utils/mediaQueries';

export const Container = styled.div`
    ${props => (!props.isEmbed ? 'position: fixed' : null)};
    top: 0;
    left: 0;
    z-index: 10000;
    width: 100vw;
    background-color: #0e0e0e;
    width: 100%;
    height: calc(100vh - 150px);
    // position: relative;
`;

export const RepeatContainer = styled.div`
    // ${props => (props.isEmbed ? 'position: fixed' : null)};
    top: 0;
    left: 0;
    z-index: 3;
    width: 100vw;
    background-color: #0e0e0e;

    width: 100vw;
    height: calc(100vh - 150px);
    display: flex;
    flex-direction: row-reverse;
    overflow: auto;
    background: ${props => (props.background ? props.background : null)};

    ${media.phone`
        display: block;
    `};
`;

// export const RepeatContainer = styled.div`
//     width: 100vw;
//     height: calc(100vh - 150px);
//     display: flex;
//     overflow: auto;
//     background: ${props => (props.background ? props.background : null)};

//     ${media.phone`
//         display: block;
//     `};
// `;



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/style.js